import CustomComponent from '../CustomComponent';

export class SignupMpdal extends CustomComponent {
	static key = 'lta-sign-up-modal';

	static get observedAttributes() {
		return [
            'id',
			'show',
			'title',
			'subtitle',
			'description',
			'login-button-label',
			'login-button-link',
			'create-account-button-label',
			'create-account-button-link'
		];
	}

    constructor() {
        super();
        this.state = {};
    }

	render() {
		const {
			show,
			title,
			subtitle,
			description,
			loginButtonLabel,
			loginButtonLink,
			createAccountButtonLabel,
			createAccountButtonLink
		} = this.props;

		const modalContent = `
            <div class="u-text-center">
                ${subtitle ? `<p class="u-text-center u-text-lta-dark-blue">${subtitle}</p>` : ''}
                ${title
                    ? `<h2 class="js-favorite-icon-action-modal-dynamic-heading u-title-case1 text-transform-uppercase u-text-lta-dark-blue">${title}</h2>`
                    : ''
                }
            </div>
            <div class="lta-modal-body u-text-center">
                ${description
                    ? `<p class="js-favorite-icon-action-modal-dynamic-description u-text-center u-body1 u-text-lta-dark-blue">${description}</p>`
                    : ''
                }
                <div class="u-flex u-flex-column md:u-flex-row u-justify-center u-gap-2 u-mt-4">
                    <div class="js-my-modal-exit--actions-item u-mb-1">
                        <lta-button 
                            classes="js-favorite-icon-action-modal-confrom-button u-rounded-none" 
                            label="${loginButtonLabel}" 
                            tag="a"
                            target="_blank"
                            href="${loginButtonLink}">
                        </lta-button>
                    </div>
                    <div class="js-my-modal-exit--actions-item u-mb-1">
                        <lta-button 
                            type="line"
                            classes="js-favorite-icon-action-modal-cancel-button lta-btn--line js-modal-venue-cancel u-rounded-none"
                            label="${createAccountButtonLabel}"
                            tag="a"
                            target="_blank"
                            href="${createAccountButtonLink}">
                        </lta-button>
                    </div>
                </div>
            </div>
        `;

		// Render the BasicModal with this content as children
		return `
			<lta-modal show=${show}>
                ${modalContent}
			</lta-modal>
		`;
	}
}
